import { useTranslation } from 'react-i18next'

import {
  Alert,
  DangerButton,
  TertiaryButton,
  Text,
  VStack,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  /** 削除対象の leg のサマリ (1 行 1 要素。 AC-BSP-139)。 */
  summaryLines: readonly string[]
  isOpen: boolean
  isSubmitting: boolean
  errorMessage: string | undefined
  onClose: () => void
  onConfirm: () => void
}

/**
 * ブロック (group) の削除確認モーダル (design `spot.html` `#block-add-modal` の
 * `#blk-delete-btn` 押下時、 および 一覧テーブルの削除アクション押下時に開く)。
 *
 * 削除は group 単位の全 leg 一括削除 (DeleteBiddingBlockApprovalRequest RPC)。
 * spot の `DeleteBidConfirmModal` と同形だが、 block 専用の i18n 文言を使う。
 * 器は spot と同じ共通 `Modal` (上寄せ・背景クリックで閉じない) を使う。
 */
export const BlockDeleteConfirmModal = ({
  summaryLines,
  isOpen,
  isSubmitting,
  errorMessage,
  onClose,
  onConfirm,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Modal
      footer={
        <>
          <TertiaryButton marginRight={3} onClick={onClose}>
            {t('common:action.cancel')}
          </TertiaryButton>
          <DangerButton loading={isSubmitting} onClick={onConfirm}>
            {t('common:action.delete')}
          </DangerButton>
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title={t('page:biddingBlock.deleteModal.title')}
    >
      <VStack align="stretch" gap={3}>
        {errorMessage !== undefined && (
          <Alert status="error" title={errorMessage} />
        )}
        <Text>{t('page:biddingBlock.deleteModal.body')}</Text>
        {summaryLines.length > 0 && (
          <VStack align="stretch" gap={1}>
            {summaryLines.map((line) => (
              <Text key={line}>{line}</Text>
            ))}
          </VStack>
        )}
      </VStack>
    </Modal>
  )
}
